var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:['c-type-color-text', _vm.defaultColorType]},_vm._l((_vm.textsToShow),function(text){return _c('span',{key:text.text + text.colorType,class:['c-type-color-text__fragment', text.colorType]},[_vm._v(_vm._s(text.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }